export const ru = {
    'categories-cannot-be-empty':
        'Фильтр должен содержать минимум одну категорию',
    'condition-control-cannot-be-empty': 'Значение не может быть пустым',
    'condition-control-greater-or-equal-min':
        'Значение должно быть больше или равно {min}',
    'condition-control-interval-size':
        'Количество элементов должно быть от {min} до {max}',
    'condition-control-invalid-value': 'Некорректное значение',
    'condition-control-less-or-equal-max':
        'Значение должно быть меньше или равно {max}',
    'condition-invalid-format': 'Некорректный формат',
    'condition-prohibited-symbols': 'Поле содержит недопустимые символы',
    'conditions-cannot-be-empty':
        'Фильтр должен содержать минимум одно условие',
    'conditions-must-be-unique':
        'Фильтр не должен содержать повторяющиеся условия',
    'default-error': 'Неизвестная ошибка: {errorCode}',
    'filters-must-be-unique':
        'Фильтр с такими условиями и целевой аудиторией уже есть',
    'name-cannot-be-empty': 'Название не может быть пустым',
    'name-greater-than-max': 'Длина названия должна быть менее {max}',
    'name-less-than-min': 'Длина названия должна быть более {min}',
    'name-prohibited-symbols': 'Название фильтра содержит недопустимые символы',
    'price-less-than-min': 'Ставка не должна быть меньше {min} {currency}',
    'price-more-than-max': 'Ставка не должна быть больше {max} {currency}'
};
